import { render, staticRenderFns } from "./DeleteClientButton.vue?vue&type=template&id=5a35e094&"
import script from "./DeleteClientButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteClientButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports